// AddressPanel.jsx
import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Box from '@mui/material/Box';
import { Card } from '@mui/material';
import ForwardIcon from '../../../images/NavBarImages/Forward_100px.png';

const backdrop = {
    hidden: { opacity: 0 },
    visible: { opacity: 0.4 },
};

const slideUp = {
    hidden: { y: '10vh', opacity: 0 },
    visible: {
        y: '-50%',
        opacity: 1,
        transition: { type: 'spring', stiffness: 80 },
    },
    exit: { y: '100vh', opacity: 0 },
};



export default function AddressPanel({ open, onClose, addresses, ThemeColor, setCostAddress, setDeliveryTransPrice,PromoCodeStatus }) {

    function lightenColor(hex, percent) {
        const num = parseInt(hex, 16);
        const r = Math.min(255, (num >> 16) + 255 * percent);
        const g = Math.min(255, ((num >> 8) & 0x00FF) + 255 * percent);
        const b = Math.min(255, (num & 0x0000FF) + 255 * percent);
        return (
            '#' +
            ((1 << 24) + (Math.round(r) << 16) + (Math.round(g) << 8) + Math.round(b))
                .toString(16)
                .slice(1)
        );
    }


    const [search, setSearch] = useState('');
    const [filtered, setFiltered] = useState([]);



    useEffect(() => {
        const match = search.toLowerCase();
        const results = addresses.filter(
            (a) =>
                a.addressName.toLowerCase().includes(match)

        );
        setFiltered(results.slice(0, 5));
    }, [search, addresses]);

    // Reset search when panel is reopened


    const selectAddress = (product) => {
        onClose()
        setCostAddress(product.addressName)
        setDeliveryTransPrice(product.transPrice)

    };


    return (
        <AnimatePresence>
            {open && (
                <>
                    {/* Dimmed background */}
                    <motion.div
                        className="fixed inset-0 z-40 bg-gray-500/30 backdrop-blur-sm"
                        variants={backdrop}
                        initial="hidden"
                        animate="visible"
                        exit="hidden"
                        onClick={onClose}
                        translate="no"
                    />

                    {/* Sliding card */}
                    <motion.div
                        className="fixed left-1/2 top-1/2 w-[90vw] max-w-xl -translate-x-1/2 -translate-y-1/2 bg-white rounded-2xl p-6 shadow-lg z-50"
                        variants={slideUp}
                        initial="hidden"
                        animate="visible"
                        exit="exit"
                        translate="no"

                    >
                        <Box sx={{
                            backgroundColor: 'white', color: 'black', paddingBottom: 0.5, bottom: 0, height: '250px', position: 'fixed', width: '100%',translate:'no'

                        }} >
                            {/* Search field */}
                            <Box sx={{
                                paddingTop:PromoCodeStatus == 1 ? '25px':'85px',
                                backgroundColor: `#${ThemeColor}`, color: 'white', bottom: 0, height: '50px', width: '100%',
                                fontFamily: 'basheer', fontSize: '16pt',translate:'no'
                            }} >
                                {'اختر العنوان'}
                                <button onClick={() => onClose()} style={{
                               marginTop:PromoCodeStatus == 1 ? '8px':'70px'   ,  width: '40px', height: '40px', borderRadius: '4px', backgroundColor: `#${ThemeColor}`, position: 'absolute', display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    top: '1vh',
                                    right: '8vw',translate:'no'
                                }} type="button">  <img src={ForwardIcon} alt="Icon" /> </button>
                            </Box>
                            <input
                          
                                style={{ padding: '10px', width: '90%', direction: 'rtl', fontFamily: 'basheer', marginTop: '10px', fontSize: '14pt', borderRadius: '5px',translate:'no' }}
                                placeholder="اكتب هنا ..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                autoFocus
                            />
                            {/* Simple address table */}
                            <div style={{
                                direction: 'rtl', fontFamily: 'basheer', marginTop: '10px', fontSize: '14pt', width: '100%', textAlign: 'start',translate:'no'

                            }} >

                                {filtered.map((a) => (

                                    <Card onClick={() => {
                                        if (a.transStaus === 1) {
                                            selectAddress(a);
                                        }
                                    }} style={{ margin: '12px', paddingTop: '5px', paddingBottom: '5px', color: a.transStaus === 0 ? 'red' : 'black',translate:'no' }}>

                                        <label style={{ margin: '5px', display: 'inline-block',translate:'no' }}>   {a.addressName}     {a.transStaus === 1 ? a.transPrice + 'د.ع' : ''}    {a.transStaus === 1 ? '' : 'لايوجد توصيل'} </label>

                                    </Card>

                                ))}



                            </div>
                        </Box>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
}
